import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrompterReportService } from '../../services/prompter-report.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { toast } from 'angular2-materialize';

@Component({
    selector: 'app-read-prompter-report',
    templateUrl: './read-prompter-report.component.html',
    styleUrls: ['./read-prompter-report.component.css', '../../app.component.css']
})

export class ReadPrompterReportComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    reports: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Proyecto', name: 'name' },
        { title: 'Apuntador', name: 'prompterName' },
        { title: 'Cantidad', className: 'center', name: 'employeeNumber' },
        /*{ title: 'Nave', name: 'shipName' },*/
        { title: 'Fecha', className: 'center', name: 'reportDate', sort: 'desc' },
        { title: 'Hora', className: 'center', name: 'captureTime' },
        { title: 'Capturó', name: 'captureUser'},
        { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
            { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
              styleClass: 'btn-floating btn waves-effect light-green darken-1' },
            { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
              styleClass: 'btn-floating btn waves-effect red darken-2', }
        ] } }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        api: {
            onEdit: this.onEdit.bind(this),
            onDelete: this.onDelete.bind(this)
        }
    };

    filterDaysVal = 1;
    lastFifteenDays: any;
    filterSearchVal = '';

    gprSubs: any;

    permissions = [];
    permissionsSubs: any;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: PrompterReportService,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });
        
        // Retrieve the object from storage
        const retrievedObject = localStorage.getItem('prompterFiltersObj');
        if (retrievedObject) {
            const storageVal = JSON.parse(retrievedObject);
            this.filterDaysVal = storageVal['daysVal'];
            this.filterSearchVal = storageVal['searchVal'];
            this.config.filtering.filterString = storageVal['searchVal'];
            localStorage.removeItem('prompterFiltersObj');
        }

        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 15);

        this.lastFifteenDays = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0);

        this.loadReports();
    }

    ngOnInit() {

    }

    loadReports() {
        let gpr: any;

        toast('Cargando...', 2000);
        if (this.filterDaysVal === 1) {
            console.log('Load reports since : ' + this.lastFifteenDays);
            gpr = this.service.getPrompterReportsSinceReportDate(this.lastFifteenDays);
        } else {
            console.log('Load all reports');
            gpr = this.service.getPrompterReports({limit: 200});
        }

        this.gprSubs = gpr.subscribe(tempReports => {
            this.gprSubs.unsubscribe();

            console.log('Show data', tempReports);
            this.reports = [];

            for (const idx in tempReports) {
                tempReports[idx].name = tempReports[idx].productionOrderObj.productionOrderName;
                tempReports[idx].prompterName = tempReports[idx].employeeObj.employeeName;
                tempReports[idx].employeeNumber = tempReports[idx].employees.length;
                /*tempReports[idx].shipName = tempReports[idx].shipObj.shipDescription;*/
                tempReports[idx].reportDate = Utils.convertDatefromStringtoISOString(tempReports[idx].reportDate);
                tempReports[idx].captureUser = (tempReports[idx].captureUser === undefined) ?
                                               'No registrado' : tempReports[idx].captureUser;

                this.reports.push(tempReports[idx]);
            }

            this.data = this.reports;
            this.length = this.data.length;
            this.onChangeTable(this.config);
            toast('Reportes cargados', 2000);
        });
    }

    onCellClick(data: any): any {
        this.saveFilters();
        this.router.navigate(['/vw_prompter_report/' + data.row.id$]);
    }

    onCreate(){
        if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
        this.router.navigate(['/add_prompter_report']);
    }

    onEdit(data: any) {
        if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
        this.saveFilters();
        this.router.navigate(['/edt_prompter_report/', data.row.id$]);
    }

    onDelete(data: any) {
        if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
        this.service.delPrompterReport(data.row.id$).then(res => {
            this.loadReports();
        });
    }

    filterDaysChange() {
        this.loadReports();
    }

    saveFilters() {
        // Put the object into storage
        const storageVal = { 'daysVal': this.filterDaysVal, 'searchVal': this.config.filtering.filterString };
        localStorage.setItem('prompterFiltersObj', JSON.stringify(storageVal));
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
